import { all, call, put, putResolve, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchMemberships() {
    try {
        const result = yield call(AxiosCall, `/shop/get_memberships/`);
        yield put(actions.fetchMembershipsSuccess(result.data.response));
    } catch (e) {
        yield put(actions.fetchMembershipsFailure(e));
    }
}

function* checkoutMembership(action) {
    try {
        // { interval: 'month' | 'year', currency: 'usd' | 'mxn', method: 'card' | 'oxxo', coupon_code, language }
        const { interval, currency, method, coupon_code, language } = action.payload;

        const result = yield call(AxiosPost, '/shop/create_checkout_memberships/', { interval, currency, method, coupon_code, language });
        yield putResolve(actions.checkoutMembershipSuccess(result.data.response));
    } catch (e) {
        yield put(actions.checkoutMembershipFailure(e));
    }
}

export default function* rootSaga() {
    yield all([
        // watchers memberships
        takeLatest(actions.FETCH_MEMBERSHIPS.REQUEST, fetchMemberships),

        // watchers memberships
        takeLatest(actions.CHECKOUT_MEMBERSHIP.REQUEST, checkoutMembership),
    ])
}